import { doorClient, conversationClient, ImResponse, resolve } from '.';

interface PageParams {
  pageSize: number;
  pageNum: number;
  orgId: number;
}

interface PageResponse {
  total: number;
  hasNext: boolean;
}

export interface BotAbandonDetail {
  storeId: string;
  storeName: string;
  alias: string;
  buyerId: string;
  buyerNick: string;
  sendTime: string;
  extra: string;
  botReplyType: Conversation.BotReplyType;
  tunnelType: General.PlatformTunnel;
}

export interface BotAbandonDetailData extends PageResponse {
  details: Array<BotAbandonDetail>;
}

/**
 * AI参与服务买家人数限制 错失服务机会记录
 */
export const getBotAbandonDetail = (params: PageParams) => {
  return resolve(
    conversationClient.get<ImResponse<BotAbandonDetailData>>('/getBotAbandonDetail', {
      params,
    }),
  );
};

export interface GetBotServeBuyerDetail extends PageParams {
  storeId: string;
  buyerId: string;
  /**
   * 选中月份1日0点的毫秒时间戳.
   */
  month?: number;
}

export interface BotServeBuyerDetail {
  sendTime: number;
  extra: string;
  botReplyType: Conversation.BotReplyType;
}

export interface BotServeBuyerDetailData extends PageResponse {
  details: Array<BotServeBuyerDetail>;
}

/**
 * AI参与服务买家人数限制 查看明细
 */
export const getBotServeBuyerDetail = (params: GetBotServeBuyerDetail) => {
  return resolve(
    conversationClient.get<ImResponse<BotServeBuyerDetailData>>('/getBotServeBuyerDetail', {
      params,
    }),
  );
};

export interface GetBotServeBuyerSummaryParams extends PageParams {
  /**
   * 选中月份1日0点的毫秒时间戳.
   */
  month?: number;
  storeId?: string;
  buyerNick?: string;
}

export interface BotServeBuyerSummary {
  storeId: string;
  storeName: string;
  alias: string;
  buyerId: string;
  buyerNick: string;
  lastSendTime: string;
  sentNum: number;
  tunnelType: General.PlatformTunnel;
}

export interface BotServeBuyerSummaryData extends PageResponse {
  summaries: Array<BotServeBuyerSummary>;
}

/**
 * AI参与服务买家人数限制 查看服务记录
 */
export const getBotServeBuyerSummary = (params: GetBotServeBuyerSummaryParams) => {
  return resolve(
    conversationClient.get<ImResponse<BotServeBuyerSummaryData>>('/getBotServeBuyerSummary', {
      params,
    }),
  );
};

export interface BotUsageSummary {
  package: string;
  sendLimit: number;
  sentNum: number;
  endTime: string;
  abandonedNum: number;
}

/**
 * AI参与服务买家人数限制 服务概况
 */
export const getBotUsageSummary = (orgId: number) => {
  return resolve(
    doorClient.get<ImResponse<BotUsageSummary>>('/aggregation/v1/getBotUsageSummary', {
      params: {
        orgId,
      },
    }),
  );
};

/**
 * AI参与服务买家人数限制 忽略此类消息
 */
export const postIgnoreBotSentLimitReached = (
  orgId: number,
  conversationId: Conversation.Conversation['conversationId'],
) => {
  return resolve(
    conversationClient.post<ImResponse<BotServeBuyerSummaryData>>('/ignoreBotSentLimitReached', {
      orgId,
      conversationId,
    }),
  );
};
